import { Injectable } from '@angular/core';
import { BaseService } from './base/base.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PaymentResultModel } from '../../model/payment.result.model';

@Injectable({
  providedIn: 'root'
})
export class TransactionService extends BaseService {

  resourceUrl = 'transactionStatus';

  //Kullanıcının Sepet Süresi Dolduktan Sonra Çağırılan Servis.
  timeoutWithoutPayment(trackingId: string): Observable<PaymentResultModel> {
    return this.get(`timeoutWithoutPayment/${trackingId}`);
  }

  getHttpParams(): HttpParams {
    return undefined;
  }

  getPath(): string {
    return this.resourceUrl;
  }
}
